export default "__VITE_ASSET__LmNU9Iva__"